<template>
  <div>
    <div class="mb-6">
      <h4 class="mb-4">You're all set to switch to Smart Pay As You Go</h4>

      <p class="mb-4">We'll switch your account on {{ formattedDate }}.</p>

      <h5 class="text-lg font-medium mb-2">What happens next:</h5>
      <ul class="ml-4 mb-6">
        <li>We'll email your Smart Pay As You Go welcome pack</li>
        <li>Download our app to manage your top-ups</li>
        <li>We'll remind you 3 days before your switch</li>
        <li>
          You can top up from midnight on the day of the switch but before 10am
          to avoid self disconnecting
        </li>
      </ul>
      <p class="mb-4">
        If you have any questions, please check our FAQs. You can also reach us
        via email at help@so.energy or chat online with an agent (available
        weekdays from 9 am to 5 pm).
      </p>
    </div>
  </div>
</template>

<script lang="ts">
  import dayjs from "dayjs"
  import { PropType } from "vue"

  export default {
    props: {
      switchDate: {
        type: [Object, String] as PropType<Date | string>,
        default: () => undefined,
      },
    },

    computed: {
      formattedDate(): string {
        return dayjs(this.switchDate).format("D MMMM YYYY")
      },
    },
  }
</script>
